import type { DomainMapper } from '../types';

const base = {
  countryCode: 'global',
  currency: 'EUR',
  environment: 'production',
  flagUrl: '/flags/GLOBAL.svg',
  languagePrimary: true,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-global.xml',
  storyblokBasePath: 'global',
  algoliaIndex: 'b2b-global-en-GB-products',
  algoliaIndexAutocomplete: 'b2b-global-en-GB-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1656,
  subFolder: true,
  googleSiteVerification: ['ypA5Zihw5nArLItaDwaLONPQEcuG4J26YTUlKQBpyqg', 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM'],
  b2b: {
    enabled: true,
    purchaseEnabled: false,
    storyblokBasePath: 'b2b',
    applicationId: 1656,
    algoliaIndex: 'b2b-global-en-GB-products',
    algoliaIndexAutocomplete: 'b2b-global-en-GB-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-global.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: false,
    storyblokBasePath: '',
    applicationId: 1655,
    algoliaIndex: 'b2c-global-en-GB-products',
    algoliaIndexAutocomplete: 'b2c-global-en-GB-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'product',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-global-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
};

const global: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default global;
